module.exports = __webpack_public_path__ + "static/media/insurance.0874ef14.jpg";